import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { processErrorInReducer } from '../helpers';


export interface ReportingFileState {
  file: string;
  isGettingFile: boolean;
 }

export const INITIAL_STATE: ReportingFileState = {
  file: '',
  isGettingFile: false,
};

const reportingFileSlice = createSlice({
  name: 'file',
  initialState: INITIAL_STATE,
  reducers: {
    getReportingFileByOrder(state: ReportingFileState, action: PayloadAction<string>) {
      state.isGettingFile = false;
    },
    getReportingFileByOrderSuccess(state: ReportingFileState, action) {
      state.isGettingFile = true;

      const { data } = action.payload;
      state.file = data;
    },
    getReportingFileByOrderFailed(state: ReportingFileState, action) {
      state.isGettingFile = true;
      processErrorInReducer(state, action);
    },
  },
  extraReducers: {},
});

export const {
  getReportingFileByOrder,
  getReportingFileByOrderSuccess,
  getReportingFileByOrderFailed,
} = reportingFileSlice.actions;

export default reportingFileSlice.reducer;
